import { render, staticRenderFns } from "./CustomerContractV2Edit.vue?vue&type=template&id=62c23058"
import script from "./CustomerContractV2Edit.vue?vue&type=script&lang=js"
export * from "./CustomerContractV2Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports